import {
  Box,
  Button,
  Center,
  Group,
  Image,
  PasswordInput,
  TextInput,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React, { useEffect, useReducer } from "react";
import { url } from "../../settings/linkUrl";
import { IconAlertCircle, IconCircleCheck } from "@tabler/icons-react";
import logo from "../../assets/logo.png";
import { isNotEmpty, useForm } from "@mantine/form";
import "./LoginAdminPage.css";
import { useNavigate } from "react-router-dom";

export default function LoginAdminPage() {
  const nav = useNavigate();
  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }

  const [data, dispatch] = useReducer(apiReducer, initialState);

  const form = useForm({
    initialValues: {
      username: "",
      password: "",
    },

    validate: {
      username: isNotEmpty("ระบุรหัสผู้ใช้งาน"),
      password: isNotEmpty("ระบุรหัสผ่าน"),
    },
  });

  const funcSubmit = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(form.values),
    };
    fetch(`${url}user/login_administrator`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        if (json.data.success === "1") {
          localStorage.setItem("token", json.data.auth);
          funcPermission();
        } else if (json.data.success === "0") {
          notifications.show({
            title: "แจ้งเตือน",
            message:
              "ไม่สามารถเข้าระบบได้ กรุณาตรวจสอบข้อมูลผู้ใช้ใหม่อีกครั้ง",
            autoClose: 3000,
            color: "red",
            icon: <IconAlertCircle />,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const funcPermission = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}user/premission`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        if (json.data.success === "1") {
          localStorage.setItem("dataUser", JSON.stringify(json.data.data));

          notifications.show({
            title: "เข้าระบบสำเร็จ",
            message: "กรุณารอสักครู่ กำลังเข้าหน้าผู้ใช้งาน",
            autoClose: 3000,
            icon: <IconCircleCheck />,
            color: "green",
          });
          nav("/administrator");
        } else if (json.success === "0") {
          notifications.show({
            title: "แจ้งเตือน",
            message:
              "ไม่สามารถเข้าระบบได้ กรุณาตรวจสอบข้อมูลผู้ใช้ใหม่อีกครั้ง",
            autoClose: 3000,
            color: "red",
            icon: <IconAlertCircle />,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  useEffect(() => {
    LoadPage();
  }, []);

  const LoadPage = () => {
    localStorage.clear();
  };

  return (
    <div className="LoginAdminPage">
      <Box className="LoginAdminCard">
        <form onSubmit={form.onSubmit(funcSubmit)}>
          <div className="LoginAdminBrand">
            <Center>
              <Image src={logo} w={96} alt="Logo" />
            </Center>
            <h1>งานผู้ดูแลระบบ</h1>
            <p>
              ซ้อมรับพระราชทานปริญญาบัตร
              <br />
              มหาวิทยาลัยราชภัฏกำแพงเพชร
            </p>
          </div>
          <TextInput
            withAsterisk
            label="รหัสผู้ใช้งาน"
            mt="md"
            placeholder="ระบุรหัสผู้ใช้งาน"
            {...form.getInputProps("username")}
          />
          <PasswordInput
            withAsterisk
            label="รหัสผ่าน"
            mt="md"
            placeholder="ระบุรหัสผ่าน"
            {...form.getInputProps("password")}
          />
          <Group justify="right" mt="xl">
            <Button
              type="submit"
              fullWidth
              loading={!!data.loading}
              className="LoginAdminSubmit"
              size="md"
            >
              เข้าสู่ระบบ
            </Button>
          </Group>
        </form>
      </Box>
    </div>
  );
}
